import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';

export const FlotasInfo = ({ infoFlota, loadingInfoFlota }) => {
  const { t } = useTranslation();
  const { routeBelongsToGroup } = useLocalizedRoutes();

  const [saldos, setSaldos] = useState({
    saldoTotal: infoFlota?.saldos?.saldo_inicio_mensual ?? '-',
    saldoRestante: infoFlota?.saldos?.saldo_disponible ?? '-',
    saldoUsado: infoFlota?.saldos?.saldo_usado ?? '-',
  });

  useEffect(() => {
    if (!loadingInfoFlota) {
      setSaldos({
        saldoTotal: infoFlota?.saldos?.saldo_inicio_mensual ?? '-',
        saldoRestante: infoFlota?.saldos?.saldo_disponible ?? '-',
        saldoUsado: infoFlota?.saldos?.saldo_usado ?? '-',
      });
    }
  }, [infoFlota, loadingInfoFlota]);

  const formatTextTipoFlota = (flota) => {
    if (flota.tipo_cuenta === 'prepago') {
      return t('flotas.tipo-cuenta.prepago');
    }

    if (flota.tipo_cuenta === 'credito') {
      return t('flotas.tipo-cuenta.credito');
    }

    return '-';
  };

  if (!routeBelongsToGroup('fleets')) {
    return null;
  }

  return (
    <>
      <span className='flotas-info-tipo-cuenta'>
        {formatTextTipoFlota(infoFlota)}
      </span>
      <div className='flotas-info-tags d-xs-block'>
        <Alert key='1' variant='danger'>
          <span className='flotas-info-tag-title'>
            {t('flotas.info.saldo-total')}
          </span>
          <span className='flotas-info-tag-number'>
            {saldos.saldoTotal} <span className='thin'>zł</span>
          </span>
        </Alert>
        <Alert key='2' variant='danger'>
          <span className='flotas-info-tag-title'>
            {t('flotas.info.saldo-restante')}
          </span>
          <span className='flotas-info-tag-number'>
            {saldos.saldoRestante} <span className='thin'>zł</span>
          </span>
        </Alert>
        <Alert key='3' variant='danger'>
          <span className='flotas-info-tag-title'>
            {t('flotas.info.saldo-usado')}
          </span>
          <span className='flotas-info-tag-number'>
            {saldos.saldoUsado} <span className='thin'>zł</span>
          </span>
        </Alert>
      </div>
    </>
  );
};
